import React from 'react';
import './PopupContent.css';

const capitalizeWords = (str) => {
    return str
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const PopupContent = ({ properties, navigate }) => {
    const handleViewDetails = () => {
        console.log('Map properties:', properties); // Debug log

        // SIMPLIFIED: Use slug first, then club_id (no separate id column)
        if (properties.slug) {
            navigate(`/club/${properties.slug}`);
        } else if (properties.club_id) {
            // Fallback to club_id - this should always be available
            navigate(`/club/${properties.club_id}`);
        } else {
            console.error('No slug or club_id available in map properties');
        }
    };

    // Format initiation fee properly (handle 0 as $0)
    const formatInitiationFee = (fee) => {
        if (fee === null || fee === undefined) return '$0';
        if (fee === 'N/A') return 'Contact Club';
        if (typeof fee === 'number') {
            return fee === 0 ? '$0' : `$${fee.toLocaleString()}`;
        }
        if (typeof fee === 'string' && !isNaN(parseFloat(fee))) {
            const parsed = parseFloat(fee);
            return parsed === 0 ? '$0' : `$${parsed.toLocaleString()}`;
        }
        return 'Contact Club';
    };

    return (
        <div className="popup-container">
            <h3>{properties.golf_course || properties.name}</h3>
            <p>
                <strong>Location:</strong> {capitalizeWords(properties.city)}, {properties.state.toUpperCase()}
            </p>
            {/* Show initiation fee if available */}
            {(properties.initiation_fee !== undefined) && (
                <p>
                    <strong>Initiation Fee:</strong> {formatInitiationFee(properties.initiation_fee)}
                </p>
            )}
            <button onClick={handleViewDetails}>
                View Course
            </button>
        </div>
    );
};

export default PopupContent;